import React, { Fragment, useContext } from 'react'
import Post from './Post'
import RightBottomPanel from './RightBottomPanel'
import RightTopPanel from './RightTopPanel'
import UserInformation from './UserInformation'
import { useEffect,useState } from 'react'
import AddPost from './AddPost'
import { TokenContext } from './Contexts/TokenContext'
import axios from 'axios'

export default function HomePageBody() {
  const {isToken} = useContext(TokenContext)
  const [posts,setPosts]= useState([])

  useEffect(() => {
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    axios.get('https://tarmeezacademy.com/api/v1/posts')
    .then((response)=> {
      setPosts(response.data.data)
    })
    // .catch((error) => console.log(error))
  }, []);
  
  return (
    <div className='flex justify-between flex-col  py-16 gap-5 '>
      {isToken ? 
      <Fragment>
      <UserInformation />
      <div className=' hidden xl:flex flex-col gap-4 mt-9 md:w-[21vw] lg:w-[18vw] 2xl:w-[20vw] fixed right-0 mr-7 '>
        <RightTopPanel />
        <RightBottomPanel />
      </div>
      <div className=' bgHome md:pl-[21vw] xl:px-10 '>
        <AddPost />
        {posts.map(post => <Post key = {post.id} title={post.title} profileImage={post.author.profile_image} contentPost={post.body} authorUsername={post.author.username} imagePost ={post.image} createTime={post.created_at} commentsCount={post.comments_count} />)}
      </div>
      </Fragment>:
      <Fragment >
        <div className='bgHome'>
           {posts.map(post => <Post key = {post.id}  title={post.title} contentPost={post.body} authorUsername={post.author.username} imagePost ={post.image} createTime={post.created_at} commentsCount={post.comments_count} />)}
        </div>
        </Fragment>}
      
      </div>
      
    
  )

}
